var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"livechannel"},[_c('video',{key:"1",ref:"videoPlayerLive",staticClass:"player liveplayer video-js vjs-theme-dt live vjs-16-9",class:{ isMobile: _vm.$isMobile() }})])}
var staticRenderFns = []

export { render, staticRenderFns }